export default __webpack_public_path__ + "static/media/light-mode.b6137c72.svg";